import { call, put, takeLatest } from "redux-saga/effects";
import { resolveLatLongForServiceability } from "../helpers/savedAddressLatLong";
import {
  failedToFetchProductListingAction,
  responseFromFetchProductListingAction,
  requestToFetchProductListingAction,
  responseFromLoadMoreProductListingAction,
  responseFromClearFiltersAction,
  requestToAddListingDataAction,
  responseFromAddListingDataAction,
  requestToFetchProductFilterInMobile,
  setProductListingFilterForMobile,
} from "../../slices/plpSlice.js";
import {
  failedToFetchDeliveryDateAction,
  requestToFetchDeliveryDateAction,
  requestToFetchInitialPlpServiceabilityAction,
  responseFromFetchDeliveryDateAction,
  clearDeliveryDatesAction,
  setIsDateLoaded,
} from "../../slices/earliestDeliveryDatesSlice.js";
import {
  getDeliveryDatesAPI,
  getPlpServiceabilityAPI,
  getProductListingDetailsAPI,
  getProductListingFilterForMobile,
} from "../../../api/plpApi/index.js";
import CookieUtil from "../../../utils/storage/cookieUtil";
import { setIsLoaderVisible } from "../../slices/cartSlice.js";

/**
 * Description placeholder
 *
 * @export
 * @returns {{}}
 */
function* fetchProductListingSaga(action) {
  try {
    yield put(setIsDateLoaded(false));
    const { filters, sortBy, sortOrder, isLoadMore, pincode } = action.payload;

    // Add UUID to the payload if not already present
    const payloadWithUUID = {
      ...action.payload,
      fnpId: action.payload.fnpId || CookieUtil.getCookie("ab_user_id"),
    };

    const response = yield getProductListingDetailsAPI(payloadWithUUID);
    if (isLoadMore) {
      // For load more requests, append new data to existing data and update pagination info
      yield put(responseFromLoadMoreProductListingAction(response));
    } else {
      if (filters === undefined) {
        yield put(responseFromClearFiltersAction({ filters: [] }));
      }
      yield put(
        responseFromFetchProductListingAction({
          response,
          filters: Array.isArray(filters) ? filters : [],
          sortOption: { sortBy, sortOrder },
        }),
      );
      yield put(setProductListingFilterForMobile(response));
    }
    const queryParams = response?.data?.map((product) => product?.productId).join(",");
    if (pincode && queryParams) {
      const latLong = yield call(resolveLatLongForServiceability);
      const earliestDeliveryDateResponse = yield getPlpServiceabilityAPI(queryParams, pincode, latLong);
      if (earliestDeliveryDateResponse) {
        yield put(responseFromFetchDeliveryDateAction(earliestDeliveryDateResponse));
        yield put(setIsDateLoaded(true));
      } else yield put(failedToFetchDeliveryDateAction({ message: "Earliest delivery dates not found", code: 404 }));
    } else if (!pincode && response) {
      // Clear delivery dates from store when pincode is not available
      yield put(clearDeliveryDatesAction());
    }

    yield put(setIsLoaderVisible(false));
  } catch (error) {
    yield put(failedToFetchProductListingAction(error));
  }
}

/**
 *
 * @param {*} action
 */
function* fetchProductListFilterForMobile(action) {
  try {
    const response = yield getProductListingFilterForMobile(action.payload);
    if (response) {
      yield put(setProductListingFilterForMobile(response));
    }
  } catch (error) {
    console.log(error);
  }
}

/**
 * Fetches PLP serviceability for SSR products after saved-address prerequisites are met.
 *
 * @param {*} action
 */
function* fetchInitialPlpServiceabilitySaga(action) {
  try {
    const { productIds, pincode } = action.payload || {};

    if (!pincode || !productIds) {
      return;
    }

    const latLong = yield call(resolveLatLongForServiceability);
    const response = yield getPlpServiceabilityAPI(productIds, pincode, latLong);

    if (response) {
      yield put(responseFromFetchDeliveryDateAction(response));
      yield put(setIsDateLoaded(true));
    } else {
      yield put(failedToFetchDeliveryDateAction({ message: "Earliest delivery dates not found", code: 404 }));
    }
  } catch (error) {
    yield put(failedToFetchDeliveryDateAction(error));
  }
}

/**
 *
 * @param {*} action
 */
function* fetchDeliveryDateSaga(action) {
  try {
    if (action) {
      const { isChooseDeliveryType, productIds, pincode } = action.payload;
      if (isChooseDeliveryType) {
        const response = yield getDeliveryDatesAPI(productIds, pincode);
        yield put(responseFromFetchDeliveryDateAction(response));
      } else {
        yield put(responseFromFetchDeliveryDateAction(action.payload));
      }
    } else {
      yield put(failedToFetchDeliveryDateAction({ message: "Earliest delivery dates not found", code: 404 }));
    }
  } catch (error) {
    yield put(failedToFetchDeliveryDateAction(error));
  }
}

/**
 *
 * @param {*} action
 */
function* addListingFilterSortSaga(action) {
  try {
    if (action) {
      yield put(responseFromAddListingDataAction(action.payload));
    } else {
      yield put(failedToFetchDeliveryDateAction({ message: "Something went wrong to fetch listing data", code: 404 }));
    }
  } catch (error) {
    yield put(failedToFetchDeliveryDateAction(error));
  }
}

/**
 * Description placeholder
 *
 * @export
 * @returns {{}}
 */
export function* watcherFetchProductListingSaga() {
  yield takeLatest(requestToFetchProductListingAction.type, fetchProductListingSaga);
}
/**
 * Description placeholder
 *
 * @export
 * @returns {{}}
 */
export function* watcherFetchProductListFilterForMobile() {
  yield takeLatest(requestToFetchProductFilterInMobile.type, fetchProductListFilterForMobile);
}

/**
 *
 */
export function* watcherFetchDeliveryDateSaga() {
  yield takeLatest(requestToFetchDeliveryDateAction.type, fetchDeliveryDateSaga);
  yield takeLatest(requestToFetchInitialPlpServiceabilityAction.type, fetchInitialPlpServiceabilitySaga);
}

/**
 *
 */
export function* watcherFiltersSaga() {
  yield takeLatest(requestToAddListingDataAction.type, addListingFilterSortSaga);
}
